import { removeNulls } from 'utils';
const hasBoilerAdapter = (card_config) => {
    const has_boiler_adapter = Boolean('open_therm' in card_config && card_config.open_therm != null);
    return has_boiler_adapter;
};
const filterCardsForCustomTab = (config, custom_config_ids) => {
    const filtered_cards = config.map((card_config) => {
        const is_selected_on_custom_tab = custom_config_ids.includes(card_config.id);
        const has_boiler_adapter = hasBoilerAdapter(card_config);
        const is_boiler_adapter_child = has_boiler_adapter &&
            custom_config_ids.includes(card_config.open_therm.boiler_adapter_id);
        if (is_selected_on_custom_tab || is_boiler_adapter_child) {
            return card_config;
        }
        return null;
    });
    return removeNulls(filtered_cards);
};
export const getDeviceShownEntities = (full_config, custom_config_ids) => {
    const shown_cards_config = Object.entries(full_config).map(([panel, config]) => {
        if (config) {
            const tab_config = filterCardsForCustomTab(config, custom_config_ids);
            const has_custom_config_cards = tab_config.length > 0;
            return has_custom_config_cards ? [panel, tab_config] : [panel, null];
        }
        return [panel, null];
    });
    return Object.fromEntries(shown_cards_config);
};
